/*! @name videojs-sprite-thumbnails @version 1.2.1 @license MIT */
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('video.js')) :
  typeof define === 'function' && define.amd ? define(['video.js'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.videojsSpriteThumbnails = factory(global.videojs));
})(this, (function (videojs) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var videojs__default = /*#__PURE__*/_interopDefaultLegacy(videojs);

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
  }

  /**
   * Set up sprite thumbnails for a player.
   *
   * @function spriteThumbs
   * @param {Player} player
   *        The current player instance.
   * @param {Plugin} plugin
   *        The current spriteThumbnails plugin instance.
   * @param {Object} options
   *        Plugin configuration options.
   */
  var spriteThumbs = function spriteThumbs(player, plugin, options) {
    var navigator = window.navigator;
    var dom = videojs__default["default"].dom || videojs__default["default"];
    var log = plugin.log || videojs__default["default"].log;
    var merge = videojs__default["default"].mergeOptions;
    var controls = player.controlBar;

    // default control bar component tree is expected
    // https://docs.videojs.com/tutorial-components.html#default-component-tree
    var progress = controls && controls.progressControl;
    var seekBar = progress && progress.seekBar;
    var mouseTimeTooltip = seekBar && seekBar.mouseTimeDisplay && seekBar.mouseTimeDisplay.timeTooltip;
    var tooltipEl = mouseTimeTooltip && mouseTimeTooltip.el();
    var tooltipStyleOrig = tooltipEl && tooltipEl.style;
    var getUrl = function getUrl(idx) {
      var urlArray = options.urlArray;
      return urlArray.length ? urlArray[idx] : options.url.replace('{index}', options.idxTag(idx));
    };
    var hijackMouseTooltip = function hijackMouseTooltip(evt) {
      var seekBarEl = seekBar.el();
      var playerWidth = player.currentWidth();
      var duration = player.duration();
      var interval = options.interval;
      var columns = options.columns;
      var responsive = options.responsive;
      var rowDuration = interval * columns;
      // spriteDuration is needed to calculate idx
      var spriteDuration = rowDuration * (options.rows || Math.ceil(duration / rowDuration));
      var position = dom.getPointerPosition(seekBarEl, evt).x * duration;
      // for single sprites idx is always 0
      var idx = Math.floor(position / spriteDuration);

      // if (idx == 0) position /= interval
      position = (position - spriteDuration * idx) / interval;
      var scaleFactor = responsive && playerWidth < responsive ? playerWidth / responsive : 1;
      var scaledWidth = options.width * scaleFactor;
      var scaledHeight = options.height * scaleFactor;
      var cleft = Math.floor(position % columns) * -scaledWidth;
      var ctop = Math.floor(position / columns) * -scaledHeight;
      var controlsTop = dom.findPosition(controls.el()).top;
      var seekBarTop = dom.findPosition(seekBarEl).top;
      // top of seekBar is 0 position
      var topOffset = -scaledHeight - Math.max(0, seekBarTop - controlsTop);
      var tooltipStyle = {
        backgroundImage: "url(\"" + getUrl(idx) + "\")",
        backgroundRepeat: 'no-repeat',
        backgroundPosition: cleft + "px " + ctop + "px",
        backgroundSize: scaledWidth * columns + "px auto",
        top: topOffset + "px",
        color: '#fff',
        textShadow: '1px 1px #000',
        // box-sizing: border-box inherited from .video-js
        border: '1px solid #000',
        // border should not overlay thumbnail area
        width: scaledWidth + 2 + "px",
        height: scaledHeight + 2 + "px"
      };
      Object.keys(tooltipStyle).forEach(function (key) {
        tooltipEl.style[key] = tooltipStyle[key];
      });
    };
    var intCheck = function intCheck(opt) {
      var val = options[opt];
      var min = opt !== 'rows' ? 1 : 0;
      if (parseInt(val, 10) !== val || val < min) {
        log(opt + " must be an integer greater than " + (min - 1));
        return false;
      }
      return true;
    };
    var downlinkCheck = function downlinkCheck() {
      var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      var downlink = options.downlink;
      if (connection && connection.downlink < downlink) {
        log.warn("connection.downlink < " + downlink);
        return false;
      }
      return true;
    };
    plugin.on('statechanged', function () {
      var pstate = plugin.state;
      var spriteEvents = ['mousemove', 'touchmove'];
      var debug = log.debug || log;
      if (pstate.ready) {
        debug('ready to show thumbnails');
        progress.on(spriteEvents, hijackMouseTooltip);
      } else {
        if (!options.url && !options.urlArray.length) {
          log('no urls given');
        }
        debug('resetting');
        progress.off(spriteEvents, hijackMouseTooltip);
        tooltipEl.style = tooltipStyleOrig;
      }
      player.toggleClass('vjs-thumbnails-ready', pstate.ready);
    });
    var init = function init() {
      // if present, merge source config with current config
      var plugName = plugin.name;
      var thumbSource = player.currentSources().filter(function (source) {
        return source.hasOwnProperty(plugName);
      })[0];
      var srcOpts = thumbSource && thumbSource[plugName];
      if (srcOpts) {
        // empty config unsets url and urlArray
        // force urlArray or url according to precedence
        var urlArray = srcOpts.urlArray;
        if (!Object.keys(srcOpts).length) {
          srcOpts = {
            url: '',
            urlArray: []
          };
          log('disabling plugin');
        } else if (urlArray && urlArray.length) {
          srcOpts.url = '';
        } else if (srcOpts.url) {
          srcOpts.urlArray = [];
        }
        plugin.options = options = merge(options, srcOpts);
      }
      plugin.setState({
        ready: !!(mouseTimeTooltip && (options.urlArray.length || options.url) && intCheck('width') && intCheck('height') && intCheck('columns') && intCheck('rows') && downlinkCheck())
      });
    };
    player.on('loadstart', init);
    init();
    player.addClass('vjs-sprite-thumbnails');
  };

  var version = "1.2.1";

  var Plugin = videojs__default["default"].getPlugin('plugin');

  /**
   * Default plugin options
   *
   * @param {String} url
   *        Location of image(s). Must be set by user. For multiple images the
   *        filename must contain the template {index} which is replaced by the
   *        zero based index number of the image in the sequence. Default: ''.
   * @param {Array} urlArray
   *        Array of image locations. Default: [].
   * @param {Integer} width
   *        Width of a thumbnail in pixels. Must be set by user. Default: 0.
   * @param {Integer} height
   *        Height of a thumbnail in pixels. Must be set by user. Default: 0.
   * @param {Integer} columns
   *        Number of thumbnail columns per image. Must be set by user.
   * @param {Integer} rows
   *        Number of thumbnail rows per image. If set to greater than 0, the
   *        plugin will expect a sequence of images. Default: 0.
   * @param {Number} interval
   *        Interval between thumbnail frames in seconds. Default: 1.
   * @param {Function} idxTag
   *        Function determining the substitiuton of the {index} template in the
   *        current url. Default: returns index as is.
   * @param {Integer} responsive
   *        Width of player below which thumbnails are reponsive. Default: 600.
   * @param {Number} downlink
   *        Minimum of NetworkInformation downlink where supported. Default: 1.5.
   *        https://developer.mozilla.org/docs/Web/API/NetworkInformation/downlink
   */
  var defaults = {
    url: '',
    idxTag: function idxTag(i) {
      return i;
    },
    urlArray: [],
    width: 0,
    height: 0,
    columns: 0,
    rows: 0,
    interval: 1,
    responsive: 600,
    downlink: 1.5
  };

  /**
   * An advanced Video.js plugin. For more information on the API
   *
   * See: https://blog.videojs.com/feature-spotlight-advanced-plugins/
   */
  var SpriteThumbnails = /*#__PURE__*/function (_Plugin) {
    _inheritsLoose(SpriteThumbnails, _Plugin);
    /**
     * Create a SpriteThumbnails plugin instance.
     *
     * @param  {Player} player
     *         A Video.js Player instance.
     *
     * @param  {Object} [options]
     *         An optional options object.
     */
    function SpriteThumbnails(player, options) {
      var _this;
      // the parent class will add player under this.player
      _this = _Plugin.call(this, player, options) || this;
      _this.options = videojs__default["default"].mergeOptions(defaults, options);
      _this.player.ready(function () {
        spriteThumbs(_this.player, _assertThisInitialized(_this), _this.options);
      });
      return _this;
    }
    return SpriteThumbnails;
  }(Plugin); // Define default values for the plugin's `state` object here.
  SpriteThumbnails.defaultState = {
    ready: false
  };

  // Include the version number.
  SpriteThumbnails.VERSION = version;

  // Register the plugin with video.js.
  videojs__default["default"].registerPlugin('spriteThumbnails', SpriteThumbnails);

  return SpriteThumbnails;

}));
